import { createApp } from 'vue'
import { createPinia } from 'pinia'
import router from './router'
import './styles/index.scss'
// Import Monaco Editor CSS for proper font loading
import "monaco-editor/min/vs/editor/editor.main.css";
import App from './App.vue'
import { authService } from './services/authService'
import { maybeRunTokenRelay } from './tokenRelay'

// Initialize MSAL before mounting the app
async function initializeApp() {
  try {
    if (await maybeRunTokenRelay()) {
      return
    }

    // Initialize authentication service
    await authService.initialize()
    console.log('MSAL initialized successfully')
    
    // Create and mount Vue app
    const app = createApp(App)
    app.use(createPinia())
    app.use(router)
    app.mount('#app')
  } catch (error) {
    console.error('Failed to initialize app:', error)

    if (await maybeRunTokenRelay()) {
      return
    }

    // Still mount the app even if auth fails
    const app = createApp(App)
    app.use(createPinia())
    app.use(router)
    app.mount('#app')
  }
}

// Start the app
initializeApp()
